var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isFooterShown)?_c('v-footer',{staticClass:"m-footer",attrs:{"fixed":""}},[_c('m-notification-bar',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }